export default {
  edit: {
    id: 'shared.action.edit',
    defaultMessage: 'Edit',
  },
}
